import { BaseApi } from './base-api';
import { Product } from '../types/product';
import { IResponsePadrao } from '../types/response-padrao';
import { Checkout } from '../types/checkout';
import { mockIp } from '../mocks/mock-ip';
import { EmitEventContract } from '../types/emit-event.contract';
import { ProcessUtmifyDto } from '../types/utmify-event';

export class ProdutoApi extends BaseApi<Product> {
  constructor() {
    super('produto');
  }

  async getForCheckout(
    id: string,
    afiliateId?: string,
    options?: { signal?: AbortSignal; country?: string },
  ): Promise<IResponsePadrao<Checkout>> {
    const params = new URLSearchParams();
    if (afiliateId) params.append('afiliateId', afiliateId);
    if (options?.country) params.append('country', options.country);

    const query = params.toString();
    const url = `/mercado-global/${id}/checkout${query ? `?${query}` : ''}`;

    return (
      await this.api.get(url, {
        signal: options?.signal,
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }


  async emitEvent(
    id: string,
    data: EmitEventContract,
  ): Promise<IResponsePadrao<{ payload: any }>> {
    return (
      await this.api.post(`/produto/facebook-pixel/${id}`, data, {
        //TODO: OBTER ISTO DO USUÁRIO FINAL
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async emitTikTokEvent(
    id: string,
    data: EmitEventContract,
  ): Promise<IResponsePadrao<{ payload: any }>> {
    return (
      await this.api.post(`/produto/tiktok-pixel/${id}`, data, {
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async emitUtmify(
    data: ProcessUtmifyDto,
  ): Promise<IResponsePadrao<{ payload: any }>> {
    return (
      await this.api.post(`/produto/utmify`, data)
    ).data;
  }
}
